/**
 * OpsKit — piezas comunes de los centros de operaciones del módulo de equipos.
 *
 * Parches, seguridad y software comparten la misma gramática visual: tarjetas
 * de KPI con icono, títulos de panel y pistas cortas. Tenerlas en un sitio evita
 * que cada pantalla derive a su aire (que es exactamente lo que pasó con las 29
 * listas).
 */

import React from 'react';

export const cardBox = {
  border: '1px solid var(--border)',
  borderRadius: 12,
  background: 'var(--bg-card)',
  padding: '12px 14px',
};

export const boxTitle = { margin: '0 0 2px', fontSize: 14, fontWeight: 700, textAlign: 'left' };
export const boxHint = { margin: '0 0 10px', fontSize: 11.5, color: 'var(--text-muted)' };

/** Tarjeta de KPI: icono en color, etiqueta, número grande y pista. */
export function KpiCard({ icon: Icon, color = '#2563eb', label, value, hint }) {
  return (
    <div style={{ ...cardBox, display: 'flex', gap: 10, alignItems: 'center' }}>
      <span
        style={{
          width: 40, height: 40, borderRadius: 10, flex: '0 0 auto',
          background: `${color}1a`, color,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {Icon ? <Icon style={{ width: 20, height: 20 }} /> : null}
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 10.5, letterSpacing: 0.5, textTransform: 'uppercase', color: 'var(--text-muted)' }}>
          {label}
        </div>
        <div style={{ fontSize: 24, fontWeight: 800, lineHeight: 1.05 }}>{value}</div>
        {hint ? <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{hint}</div> : null}
      </div>
    </div>
  );
}

export const OPS_COLORS = {
  ok: '#16a34a',
  warn: '#eab308',
  bad: '#dc2626',
  info: '#2563eb',
  muted: '#94a3b8',
};
